
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.804 15.79a.984.984 0 001.392 0l3.712-3.712a.984.984 0 00-1.392-1.393l-2.032 2.032V1.97a.984.984 0 10-1.968 0v10.748l-2.032-2.032a.984.984 0 00-1.392 1.393l3.712 3.712z"}}),_c('path',{attrs:{"d":"M19.031 9.516a.984.984 0 00-.984.984v7.547H2.953V10.5a.984.984 0 10-1.969 0v7.875a1.64 1.64 0 001.641 1.64h15.75a1.64 1.64 0 001.64-1.64V10.5a.984.984 0 00-.984-.984z"}})])
          )
        }
      }
    